var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PCancelable_instances, _PCancelable_cancelHandlers, _PCancelable_rejectOnCancel, _PCancelable_state, _PCancelable_promise, _PCancelable_reject, _PCancelable_setState;
var CancelError = /** @class */ (function (_super) {
    __extends(CancelError, _super);
    function CancelError(reason) {
        var _this = _super.call(this, reason || 'Promise was canceled') || this;
        _this.name = 'CancelError';
        return _this;
    }
    Object.defineProperty(CancelError.prototype, "isCanceled", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return CancelError;
}(Error));
export { CancelError };
var promiseState = Object.freeze({
    pending: Symbol('pending'),
    canceled: Symbol('canceled'),
    resolved: Symbol('resolved'),
    rejected: Symbol('rejected')
});
var PCancelable = /** @class */ (function () {
    function PCancelable(executor) {
        var _this = this;
        _PCancelable_instances.add(this);
        _PCancelable_cancelHandlers.set(this, []);
        _PCancelable_rejectOnCancel.set(this, true);
        _PCancelable_state.set(this, promiseState.pending);
        _PCancelable_promise.set(this, void 0);
        _PCancelable_reject.set(this, void 0);
        __classPrivateFieldSet(this, _PCancelable_promise, new Promise(function (resolve, reject) {
            __classPrivateFieldSet(_this, _PCancelable_reject, reject, "f");
            var onResolve = function (value) {
                if (__classPrivateFieldGet(_this, _PCancelable_state, "f") !== promiseState.canceled || !onCancel.shouldReject) {
                    resolve(value);
                    __classPrivateFieldGet(_this, _PCancelable_instances, "m", _PCancelable_setState).call(_this, promiseState.resolved);
                }
            };
            var onReject = function (error) {
                if (__classPrivateFieldGet(_this, _PCancelable_state, "f") !== promiseState.canceled || !onCancel.shouldReject) {
                    reject(error);
                    __classPrivateFieldGet(_this, _PCancelable_instances, "m", _PCancelable_setState).call(_this, promiseState.rejected);
                }
            };
            var onCancel = function (handler) {
                if (__classPrivateFieldGet(_this, _PCancelable_state, "f") !== promiseState.pending) {
                    throw new Error("The `onCancel` handler was attached after the promise ".concat(__classPrivateFieldGet(_this, _PCancelable_state, "f").description, "."));
                }
                __classPrivateFieldGet(_this, _PCancelable_cancelHandlers, "f").push(handler);
            };
            Object.defineProperties(onCancel, {
                shouldReject: {
                    get: function () { return __classPrivateFieldGet(_this, _PCancelable_rejectOnCancel, "f"); },
                    set: function (boolean) {
                        __classPrivateFieldSet(_this, _PCancelable_rejectOnCancel, boolean, "f");
                    }
                }
            });
            executor(onResolve, onReject, onCancel);
        }), "f");
    }
    PCancelable.fn = function (userFunction) {
        return function () {
            var arguments_ = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                arguments_[_i] = arguments[_i];
            }
            return new PCancelable(function (resolve, reject, onCancel) {
                arguments_.push(onCancel);
                userFunction.apply(void 0, arguments_).then(resolve, reject);
            });
        };
    };
    // eslint-disable-next-line unicorn/no-thenable
    PCancelable.prototype.then = function (onFulfilled, onRejected) {
        return __classPrivateFieldGet(this, _PCancelable_promise, "f").then(onFulfilled, onRejected);
    };
    PCancelable.prototype["catch"] = function (onRejected) {
        return __classPrivateFieldGet(this, _PCancelable_promise, "f")["catch"](onRejected);
    };
    PCancelable.prototype["finally"] = function (onFinally) {
        return __classPrivateFieldGet(this, _PCancelable_promise, "f")["finally"](onFinally);
    };
    PCancelable.prototype.cancel = function (reason) {
        if (__classPrivateFieldGet(this, _PCancelable_state, "f") !== promiseState.pending) {
            return;
        }
        __classPrivateFieldGet(this, _PCancelable_instances, "m", _PCancelable_setState).call(this, promiseState.canceled);
        if (__classPrivateFieldGet(this, _PCancelable_cancelHandlers, "f").length > 0) {
            try {
                for (var _i = 0, _a = __classPrivateFieldGet(this, _PCancelable_cancelHandlers, "f"); _i < _a.length; _i++) {
                    var handler = _a[_i];
                    handler();
                }
            }
            catch (error) {
                __classPrivateFieldGet(this, _PCancelable_reject, "f").call(this, error);
                return;
            }
        }
        if (__classPrivateFieldGet(this, _PCancelable_rejectOnCancel, "f")) {
            __classPrivateFieldGet(this, _PCancelable_reject, "f").call(this, new CancelError(reason));
        }
    };
    Object.defineProperty(PCancelable.prototype, "isCanceled", {
        get: function () {
            return __classPrivateFieldGet(this, _PCancelable_state, "f") === promiseState.canceled;
        },
        enumerable: false,
        configurable: true
    });
    return PCancelable;
}());
export default PCancelable;
_PCancelable_cancelHandlers = new WeakMap(), _PCancelable_rejectOnCancel = new WeakMap(), _PCancelable_state = new WeakMap(), _PCancelable_promise = new WeakMap(), _PCancelable_reject = new WeakMap(), _PCancelable_instances = new WeakSet(), _PCancelable_setState = function _PCancelable_setState(state) {
    if (__classPrivateFieldGet(this, _PCancelable_state, "f") === promiseState.pending) {
        __classPrivateFieldSet(this, _PCancelable_state, state, "f");
    }
};
Object.setPrototypeOf(PCancelable.prototype, Promise.prototype);
